import { render, staticRenderFns } from "./message-box.vue?vue&type=template&id=4a69ea5b&scoped=true&"
import script from "./message-box.vue?vue&type=script&lang=js&"
export * from "./message-box.vue?vue&type=script&lang=js&"
import style0 from "./message-box.vue?vue&type=style&index=0&id=4a69ea5b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a69ea5b",
  null
  
)

export default component.exports